import request from '@/utils/request'
// 获取url
export function getUrl () {
  return request({
    url: '/auth/api/getUrl',
    method: 'get'
  })
}
// 登录
export function login (data) {
  return request({
    url: '/auth/api/wapLogin',
    method: 'post',
    data
  })
}
// 获取验证码
export function getCode (params) {
  return request({
    url: '/auth/api/getCode',
    method: 'get',
    params
  })
}
// 微信授权
export function wxAuth (params) {
  return request({
    url: '/auth/api/wxAuth',
    method: 'get',
    params
  })
}

// 退出
export function exit (params) {
  return request({
    url: '/auth/api/exit',
    method: 'get',
    params
  })
}
